export enum LoadingStatus {
  IDLE,
  PENDING,
  SUCCEEDED,
  FAILED,
}

export const isLoadingFinalized = (status: LoadingStatus) =>
  [LoadingStatus.FAILED, LoadingStatus.SUCCEEDED].includes(status);
